import React, { useImperativeHandle, forwardRef, useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Chips } from 'primereact/chips';
import { Checkbox } from 'primereact/checkbox';
import axios from "axios";
import { triggerAlert } from "utils/CommonFunctions";

const NotesCompanies1 = forwardRef(({ selectedCustomers }, ref) => {
    const [visibleLinkJob, setVisibleLinkJob] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [valueNotes, setValueNotes] = useState(['Tech Corp']);
    const [popchecked, setPopchecked] = useState(false);
    const [candidateName, setCandidateName] = useState("Anupam Diridhar, John Doe, Amith, Sagar");
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [subject, setSubject] = useState("");
    const [notes, setNotes] = useState("");
    const [notesError, setNotesError] = useState(""); // State for notes validation error


    const [userId, setUserId] = useState('')
    
          useEffect(() => {
                const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
                if (userInfo && userInfo.user_details) {
                    setUserId([userInfo.user_details.unique_user_id]);
                }
            }, []);

    useImperativeHandle(ref, () => ({
          openLinkJobModal: () => setVisibleLinkJob(true),
        }));
      const handlePopupCheckbox = (e) => {
        setPopchecked(e.checked);
      };

    const [selectedJobs, setSelectedJobs] = useState([]);
    const [jobs] = useState([
        { id: "Varun Digital Media", title: "www.varundigitalmedia.com" },
        { id: "Innovate Solutions", title: "www.innovatesolutions.com" },
        { id: "Green Ventures", title: "www.greenventures.com" },
        { id: "Future Tech", title: "www.futuretech.com" },
        { id: "Healthify Solutions", title: "www.healthifysolutions.com" },
    ]);

    const [searchText, setSearchText] = useState('');
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');

    const handleIconClick = () => {
        setJobDetailsVisible(true);
    };

    
    const handleSave = () => {
        if (selectedJobs.length > 0) {
            const selectedJob = selectedJobs[0];
            const selectedJobTitle = `${selectedJob.id}, ${selectedJob.title}`;
            setSelectedJobTitles(selectedJobTitle);
            setJobDetailsVisible(false);
        }
    };

    const handleRefresh = () => {
        setSelectedJobs([]);
        setSearchText('');
    };

    const filteredJobs = jobs.filter(
        (job) =>
            job.title.toLowerCase().includes(searchText.toLowerCase()) ||
            job.contact?.toLowerCase().includes(searchText.toLowerCase()) ||
            job.id.toString().includes(searchText)
    );

    // Notes validation function
    const validateNotes = (notesValue) => {
        if (!notesValue.trim()) {
            return "Notes cannot be empty.";
        }
        if (notesValue.length < 5) {
            return "Notes must be at least 5 characters long.";
        }
        if (notesValue.length > 5000) {
            return "Notes cannot exceed 5000 characters.";
        }
        return "";
    };

    // Handle notes input change with validation
    const handleNotesChange = (e) => {
        const newNotes = e.target.value;
        setNotes(newNotes);
        setNotesError(validateNotes(newNotes)); // Validate on change
    };

    // Updated handleSaveNote with validation
    const handleSaveNote = async () => {
        const validationError = validateNotes(notes);
        if (validationError) {
            setNotesError(validationError);
            // setVisibleLinkJob(false);
            // triggerAlert("error", "Validation Error", validationError);
            return;
        }

        try {
            const companyIds = Array.isArray(selectedCustomers)
                ? selectedCustomers.map((cust) => cust.company_id).filter(Boolean).join(",")
                : "";
            if (!companyIds) {
                triggerAlert("error", "Error", "No valid companies selected.");
                return;
            }

            const response = await axios.post(`/api/v1/notes/`, {
                company_id: companyIds,
                notes: notes,
            });
            triggerAlert("success", "Success", "Notes Created Successfully!");
            setNotes("");
            setNotesError(""); // Clear error on successful save
            setVisibleLinkJob(false);
        } catch (error) {
            console.error("Error creating note:", error);
            triggerAlert("error", "Error", "Failed to create note.");
        }
    };

    const selectedCompanyNames = useMemo(() => {
        if (!Array.isArray(selectedCustomers) || selectedCustomers.length === 0) {
            return "";
        }
        return selectedCustomers
            .map((customer) => customer?.company_name || "Unknown")
            .filter(Boolean)
            .join(", ");
    }, [selectedCustomers]);

    return (
        <React.Fragment>
            <button
                type="button"
                className="btn btn-secondary icons-btn me-1"
                onClick={() => setVisibleLinkJob(true)}
            >
                <i className="pi pi-file"></i>
            </button>

            <Dialog header={`Note - ${selectedCompanyNames}`} visible={visibleLinkJob} onHide={() => {setVisibleLinkJob(false); setNotes("");}}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Type
                            </label>
                            <InputText
                                id="candidate"
                                value="Note"
                                readOnly
                                className="w-full"
                                placeholder="Note"
                                disabled
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)}
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy"
                                hourFormat="12"
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">Companies</label>
                            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                <InputText
                                    id="Companies"
                                    value={selectedCompanyNames}
                                    placeholder="Varun Digital Media, www.varundigitalmedia.com"
                                    className="w-full"
                                    style={{ paddingRight: '2rem' }}
                                    disabled
                                />
                            </div>
                            <Dialog
                                header="Companies Details"
                                visible={jobDetailsVisible}
                                onHide={() => setJobDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Jobs"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }}
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>

                                <DataTable
                                    value={filteredJobs}
                                    paginator
                                    rows={5}
                                    selection={selectedJobs}
                                    onSelectionChange={(e) => setSelectedJobs(e.value)}
                                    dataKey="id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    size="small"
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="id" header="Companies ID" />
                                    <Column field="title" header="Companies Title" />
                                    <Column field="contact" header="Contact" />
                                </DataTable>

                                <div className="d-flex mt-3">
                                    <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                    <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={handleNotesChange} // Updated to use validation handler
                                rows={3}
                                cols={20}
                                className={`w-full ${notesError ? 'p-invalid' : ''}`} // Add invalid class if error
                                placeholder="Enter your notes here..."
                                autoResize
                            />
                            {notesError && <small className="p-error">{notesError}</small>} {/* Display error message */}
                        </div>
                    </Col>
                </Row>
                <Row className="align-items-center">
                    <Col lg={2}>
                        <div className="d-flex align-items-center">
                            <Checkbox
                                inputId="checkbox"
                                checked={popchecked}
                                onChange={handlePopupCheckbox}
                            />
                            <label htmlFor="username" className="ms-2 mt-2">
                                Private
                            </label>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="field notes-chip">
                            <label htmlFor="userId" className="block mb-0">
                                User ID
                            </label>
                            <Chips 
                            disabled
                            value={userId} 
                            // onChange={(e) => setValueNotes(e.value)} 
                            className="w-full" />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSaveNote}>Add Note</button>
                        </div>
                    </Col>
                </Row>
            </Dialog>
        </React.Fragment>
    );
});

export default NotesCompanies1;